// Per-status presentation for a company user's lifecycle status — one chip
// spec (i18n label key + Chip variant) per CompanyUserStatus value. Used by
// the people table's Status column and the detail drawer's profile card.

import { CompanyUserStatus } from '@/api/endpoints/peopleApi';
import type { ChipVariant } from '@/components/common/Chip';

export interface PersonStatusMeta {
  labelKey: string;
  variant: ChipVariant;
  dot?: boolean;
}

export const PERSON_STATUS_META: Record<CompanyUserStatus, PersonStatusMeta> = {
  [CompanyUserStatus.ACTIVE]: {
    labelKey: 'people_status_active',
    variant: 'success',
    dot: true,
  },
  [CompanyUserStatus.PENDING]: {
    labelKey: 'people_status_pending',
    variant: 'warning',
  },
  [CompanyUserStatus.ADMIN_INVITE]: {
    labelKey: 'people_status_admin_invite',
    variant: 'info',
  },
  [CompanyUserStatus.ARCHIVED]: {
    labelKey: 'people_status_archived',
    variant: 'neutral',
  },
  [CompanyUserStatus.BLOCKED]: {
    labelKey: 'people_status_blocked',
    variant: 'danger',
  },
};
